export const FEE_PCT = Number(process.env.REACT_APP_PLATFORM_FEE_PCT || 0.12);
export const FEE_LABEL = `${Math.round(FEE_PCT * 100)}%`;

export const feeOn = (amount) => Math.round((Number(amount) || 0) * FEE_PCT * 100) / 100;
export const builderTotal = (amount) => Math.round(((Number(amount) || 0) + feeOn(amount)) * 100) / 100;
export const money = (n) => `$${(Number(n) || 0).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
